<template>
  <!-- test data :: <pre>{{ transactions }}</pre>  -->
  <Background>
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PBTPay.png"
          alt="PBT DI SELURUH MALAYSIA"
          class="pbt-image"
        >
  
        <div class="line-under-image" />
      </div>

      <div class="pbtpay-status">
        <h2>PBTPay</h2>     
        <div class="pbtpay-box">
          <div class="image-container">
            <img
              src="@/assets/jkt/PBT/pbt_menu_2.png"
              alt="First Image"
            >
            <div class="text-overlay">
              <h3>Jumlah PBT</h3>
              <p>{{ allData.pbtcountlive || 0 }}</p>
            </div>
          </div>

          <div class="image-container">
            <img
              src="@/assets/jkt/PBT/pbt_menu_3.png"
              alt="Second Image"
            >
            <div class="text-overlay-right">
              <h3>Jumlah Kutipan</h3>
              <p>RM{{ formatToBillion(pbtPay.totalall || 0) }}</p>
            </div>
          </div>

          <div class="image-container">
            <img
              src="@/assets/jkt/PBT/pbt_menu_4.png"
              alt="Third Image"
            >
            <div class="text-overlay">
              <h3>Jumlah Transaksi</h3>
              <p>{{ pbtPay.totaltrx || 0 }}</p>
            </div>
          </div>

          <div class="image-container">
            <img
              src="@/assets/jkt/PBT/pbt_menu_5.png"
              alt="Fourth Image"
            >
            <div class="text-overlay-right">
              <h3>Jumlah Pengguna</h3>
              <h3>Berdaftar</h3>
              <p>{{ pbtPay.registered || 0 }}</p>
            </div>
          </div>

          <div class="image-container">
            <img
              src="@/assets/jkt/PBT/pbt_menu_6.png"
              alt="Fifth Image"
            >
            <div class="text-overlay">
              <h3>Pengguna</h3>
              <p>{{ pbtPay.users || 0 }}</p>
            </div>
          </div>
        </div>
        <Update />
      </div>


      
      <div class="pbtpay-status">
        <h2>STATUS TRANSAKSI PBTPay</h2>
        <VTable class="text-no-wrap">
          <thead>
            <tr>
              <th>No</th>
              <th>Kutipan</th>
              <th>Jumlah (RM)</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in transactions"
              :key="item.no"
            >
              <td>{{ item.no }}</td>
              <td>{{ item.kutipan }}</td>
              <td>RM {{ item.jumlah }}</td>
            </tr>
          </tbody>
        </VTable>
        <Update />
      </div>
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'


import { useHttpService } from "@/httpService"
import { format } from 'd3-format'
import moment from "moment"
import { onMounted, ref } from 'vue'


const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const transactions = ref([]) 

const pbtPay = ref({
  date: null,
  users: 0,
  pbttaksiran: 0,
  pbtkompaun: 0,
  pbtsewa: 0,
  pbtpelbagai: 0,
  pbtosc: 0,
  pbtpaypbtcount: 0,
  overallPbtCount: 0,
  pbtosccount: 0,
  totalall: 0,
  totaltrx: 0,
  registered: 0,
  kutipanTahun: {},
})

const allData = ref({
  pbtcountlive: 0,
  totalall: 0,
  totaltrx: 0,
  registered: 0,
  users: 0,
})


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

async function loadDataFromApiPbtPay() {
  try {
    // const response = await httpGet('pengurusan-maklumat/pbtpay')

    // allData.value = response.data[0]

    const res = await fetch('https://jktgateway.kpkt.gov.my/api/pengurusan-maklumat/pbtpay')
    const json = await res.json()

    console.log('API raw response:', json)

    if (!Array.isArray(json.data) || json.data.length === 0) {
      console.error('API returned invalid data:', json)
      
      return
    }

    allData.value = json.data[0]

    pbtPay.value = {
      date: moment(allData.value.pdate).toDate(),
      users: numberWithCommas(allData.value.users),
      pbttaksiran: allData.value.pbttaksiran,
      pbtkompaun: allData.value.pbtkompaun,
      pbtsewa: allData.value.pbtsewa,
      pbtpelbagai: allData.value.pbtpelbagai,
      pbtosc: allData.value.pbtosc,
      pbtpaypbtcount: allData.value.pbtcountlive,
      overallPbtCount: allData.value.pbtcount,
      pbtosccount: allData.value.pbtcountosc,
      totalall: allData.value.totalall,
      totaltrx: numberWithCommas(allData.value.totaltrx),
      registered: numberWithCommas(allData.value.registered),
      kutipanTahun: {},
    }

    const currentYear = moment().year()
    for (let i = 0; i < 5; i++) {
      const year = currentYear - i

      pbtPay.value.kutipanTahun[year] = format('.4s')(allData.value['yr' + year])
    }
  } catch (err) {
    console.error('loadDataFromApiPbtPay failed:', err)
  }

  transactions.value = []

  const currentYear = moment().year()

  for (let i = 0; i < 5; i++) {
    const year = currentYear - i

    transactions.value.push({
      no: i + 1,
      kutipan: `Kutipan Tahun ${year}`,
      jumlah: pbtPay.value.kutipanTahun[year] || '0',
    })
  }
}

function formatToBillion(value) {
  if (!value) return "0"
  const num = parseFloat(value)
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(2) + "B"
  }

  return num.toLocaleString()
}

onMounted(() => {
  loadDataFromApiPbtPay()
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}


.map-gap {
  margin-block: 10px;
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
  
}

.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.pbtpay-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: auto;
  max-inline-size: 900px;
}

.image-container img {
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}


.text-overlay {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  inset-inline-start: 10%;
  text-align: start;
  transform: translateY(-50%);
}


.text-overlay-right {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  inset-inline-end: 10%;
  text-align: end;
  transform: translateY(-50%);
}

.text-overlay h3,
.text-overlay-right h3 {
  margin: 0;
  color: white;
  font-size: 36px;
  font-weight: bold;
}

.text-overlay p,
.text-overlay-right p {
  margin: 0;
  font-size: 64px;
  font-weight: bold;
  line-height: 1.2;
}



@media (max-width: 768px) {
  .pbtpay-box {
    flex-direction: column;
    align-items: center;
  }

  h1 {
    font-size: 1.5rem;
  }

  .text-overlay h3,
  .text-overlay-right h3 {
    font-size: 4vw;
  }

  .text-overlay p,
  .text-overlay-right p {
    font-size: 7vw; 
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .pbtpay-item h2 {
    font-size: 1.5rem;
  }

  .text-overlay h3,
  .text-overlay-right h3 {
    font-size: 4vw;
  }

  .text-overlay p,
  .text-overlay-right p {
    font-size: 6vw; 
  }
}
</style>
